import { useRef } from 'react';
import { observer } from 'mobx-react';
import FormCommon, { FormCommonInstance } from '@/components/FormCommon';
import { CheckboxItem, SelectItem, BaseItem } from '@/components/FormItem';
import {
  useCustomLang,
  useLanguage,
  useCustomInput,
  useProduct,
} from '@/store';
import { $fm } from '@/Intl';

import LangSelect from './LangSelect';
import CustomLang from './CustomLang';
import CustomInput from './CustomInput';

export default observer(() => {
  const formRef = useRef<FormCommonInstance>(null);
  const [language, updateLanguage, defaults] = useLanguage();
  const [, setCustomLang] = useCustomLang();
  const [, setCustInput] = useCustomInput();
  const [product] = useProduct();

  return (
    <FormCommon
      initialValues={language}
      onUpdate={updateLanguage}
      defaults={defaults}
      ref={formRef}
      onReset={() => {
        setCustomLang(null);
        setCustInput(null);
      }}
    >
      {/* 语言设置 */}
      <CheckboxItem
        label={$fm('LANG_SET')}
        name='langApply'
        onChange={(e) => {
          if (!e.target.checked) {
            formRef.current?.updateValue({
              langCode: 'en,US',
            });
            setCustomLang(null);
          }
        }}
      />
      {/* 选择语言 */}
      <BaseItem
        label={$fm('LANG_SELECT')}
        name='langCode'
        depends={{
          langApply: 1,
        }}
      >
        <LangSelect />
      </BaseItem>

      {/* 自定义语言 */}
      <BaseItem
        label={$fm('CUSTOM_LANG')}
        name='langFile'
        depends={{
          langApply: 1,
        }}
      >
        <CustomLang />
      </BaseItem>

      {/* 默认输入法 */}
      <SelectItem
        label={$fm('DEF_INPUT_METHOD')}
        name='inputMethod'
        options={[
          { v: 0, t: $fm('ANDROID_KEY') },
          { v: 1, t: $fm('GOOGLE_PINYIN') },
          {
            v: 2,
            t: 'Japanese IME',
            hide: ['gac2570', 'gxv3450', 'gxv3470', 'gxv3480'].includes(
              product,
            ),
          },
          { v: -1, t: $fm('CUSTOM_INPUT_METHOD') },
        ]}
        onChange={(v) => {
          if (v !== -1) {
            setCustInput(null);
          }
        }}
      />
      {/* 自定义输入法 */}
      <BaseItem
        label={$fm('CUSTOM_INPUT_METHOD')}
        name='custInputMethodName'
        depends={{
          inputMethod: -1,
        }}
      >
        {/* todo */}
        <CustomInput />
      </BaseItem>
    </FormCommon>
  );
});
